import { getConfig } from '~/config/environment';
import { useShopStore } from '~/stores/shop';

const SHOPIFY_THEME_EXTENSION_ID = getConfig('APP')?.SHOPIFY_THEME_EXTENSION_ID;
const SHOPIFY_THEME_EXTENSION_HANDLE = getConfig('APP')?.SHOPIFY_THEME_EXTENSION_HANDLE;

interface IAppExtensionResult {
  extensionLink: string;
}

export const useAppExtension = (): IAppExtensionResult => {
  const shopifyDomain = useShopStore((state) => state.shopInfo?.shopifyDomain);
  const extensionLink = `https://${shopifyDomain}/admin/themes/current/editor?context=apps&activateAppId=${SHOPIFY_THEME_EXTENSION_ID}/${SHOPIFY_THEME_EXTENSION_HANDLE}`;

  return {
    extensionLink,
  };
};
